
export default {
  props: {
    module: Object,
    group: Object,
  },

  data() {
    return {
      isReady: false,
      template: {
        slider: {
          label: 'Slider',
          module: 'slider',
          min: 1000,
          max: 5000,
          step: 500,
          icons: [],
        },
      },
    }
  },

  watch: {
    group: {
      handler(val) {
        this.$emit('valid', true)
      },
      deep: true,
      immediate: true,
    },
  },

  computed: {
    _group: {
      set(value) {
        this.$emit('update:group', value)
      },

      get() {
        return this.group
      },
    },
  },

  mounted() {
    if (!this.group) this._group = {}

    this.template.slider.min = parseInt(this.module.content.min)
    this.template.slider.max = parseInt(this.module.content.max)
    this.template.slider.step = parseInt(this.module.content.step)
    this.template.slider.icons = this.module.content.icons
    this.isReady = true
  },
}
